import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'issue-create.common.navigation-discard-changes-prompt.title',
		defaultMessage: 'Your changes won’t be saved',
		description: 'Title for confirm-dismiss modal popup',
	},
	cancelButtonLabel: {
		id: 'issue-create.common.navigation-discard-changes-prompt.cancel-button-label',
		defaultMessage: 'Go back',
		description: 'Label for secondary button for confirm-dismiss modal popup',
	},
	confirmLabel: {
		id: 'issue-create.common.navigation-discard-changes-prompt.confirm-label',
		defaultMessage: 'Discard',
		description: 'Label for primary button for confirm-dismiss modal popup',
	},
	description: {
		id: 'issue-create.common.navigation-discard-changes-prompt.description',
		defaultMessage: 'We won’t be able to save your data if you move away from this page.',
		description: 'Description for confirm-dismiss modal popup',
	},
});
